/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coached_Live_TitleInputs */

const en_coached_live_title = /** @type {(inputs: Coached_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training with your coach`)
};

const pl_coached_live_title = /** @type {(inputs: Coached_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening z trenerem`)
};

/**
* | output |
* | --- |
* | "Training with your coach" |
*
* @param {Coached_Live_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coached_live_title = /** @type {((inputs?: Coached_Live_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coached_Live_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coached_live_title(inputs)
	return en_coached_live_title(inputs)
});